import { render, staticRenderFns } from "./PageLoader.html?vue&type=template&id=0a7aa133&external"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports